export enum SpecialKeys {
  ESC = 27,
  ENTER = 13,
  UP = 38,
  DOWN = 40,
  RIGHT = 39,
  LEFT = 37,
  SHIFT = 16,
  TAB = 9,
  CTRL = 17,
  ALT = 18
}
